export default function parent(element, selector) {
    const check = typeof selector === 'function' ? selector : el => el.classList.contains(selector)

    do {
        if (check(element)) {
            return element
        }

        element = element.parentNode
    } while (element.parentNode)

    return null
}
